<template>
  <div class="map-container">
    <div ref="location-map" :style="{ height: height }" />
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl"

export default {
  props: {
    lat: { type: String, default: null },
    lng: { type: String, default: null },
    interactive: { type: Boolean, default: true },
    height: { type: String, default: "auto" }
  },

  data() {
    return {
      map: null,
      marker: null
    }
  },

  computed: {
    center() {
      return [this.lng, this.lat]
    }
  },

  watch: {
    center() {
      this.map.flyTo({ center: this.center, screenSpeed: 10 })
      this.marker.setLngLat(this.center)
    }
  },

  mounted() {
    const center = this.center
    const token = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN
    if (!token) {
      return
    }

    mapboxgl.accessToken = token
    this.map = new mapboxgl.Map({
      container: this.$refs["location-map"],
      style: "mapbox://styles/mapbox/streets-v11",
      center,
      zoom: 13,
      interactive: this.interactive,
      preserveDrawingBuffer: true
    })

    this.marker = new mapboxgl.Marker().setLngLat(this.center).addTo(this.map)
  },

  methods: {
    resizeMap() {
      this.map.resize()
    }
  }
}
</script>

<style lang="scss">
@import "~mapbox-gl/dist/mapbox-gl.css";

.map-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .mapboxgl-map {
    position: static;

    .mapboxgl-canvas-container {
      height: 100%;
    }

    .mapboxgl-canvas {
      position: relative;
      height: 100% !important;
      width: 100% !important;
    }
  }
}
</style>
